module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "weitgmefm"
    }
  }, [_c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("All the world’s a stage,")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("And all the men and women merely players;")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("They have their exits and their entrances,")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("And one man in his time plays many parts,")])]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("His acts being seven ages.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-override-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', [_vm._v("—Shakespeare")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4798650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 69
// module chunks = 0